import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import OpenSource from "./pages/OpenSource";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import UseCasePage from "./pages/UseCase";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import CompareIndex from "./pages/CompareIndex";
import ComparisonPage from "./pages/ComparisonPage";
import IntegrationPage from "./pages/IntegrationPage";
import GlossaryIndex from "./pages/GlossaryIndex";
import GlossaryTerm from "./pages/GlossaryTerm";
import Vision from "./pages/Vision";

const DefensePage = lazy(() => import("./pages/verticals/DefensePage"));
const DistributorsPage = lazy(() => import("./pages/verticals/DistributorsPage"));
const AdsManagerPage = lazy(() => import("./pages/verticals/AdsManagerPage"));

export default function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/open-source" element={<OpenSource />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/use-cases/:slug" element={<UseCasePage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/compare" element={<CompareIndex />} />
        <Route path="/compare/:slug" element={<ComparisonPage />} />
        <Route path="/integrations/i/:slug" element={<IntegrationPage />} />
        <Route path="/glossary" element={<GlossaryIndex />} />
        <Route path="/glossary/:term" element={<GlossaryTerm />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/defense" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><DefensePage /></Suspense>} />
        <Route path="/distributors" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><DistributorsPage /></Suspense>} />
        <Route path="/ads" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><AdsManagerPage /></Suspense>} />
        {/* Catch-all: redirect to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
